import { gaTracking, getCurrentPageLocation, normalizeString } from "@lib/ga";
import { mapInsuranceName } from "@lib/insuranceMapping";

import type { GAVoteClickParameters } from "types/ga";

type VoteClickInput = {
  title: string;
  index?: number;
  link_text: GAVoteClickParameters["link_text"];
  insurance?: string;
};

/**
 * Pushes a `vote_click` event to the dataLayer when the user clicks thumbs
 * up/down in the CES feedback module. GTM picks the event up and fires the
 * Merkle survey tag, which opens the survey modal without a page reload.
 *
 * @see /GAExamples/vote_click.js
 * @see https://dev.azure.com/afaforsakring2/DigitalAnalys/_wiki/wikis/DigitalAnalys.wiki/29298 (anchor vote_click)
 */
export const trackVoteClick = ({ title, index, link_text, insurance }: VoteClickInput): void => {
  gaTracking({
    event: "vote_click",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      title: normalizeString(title) ?? "",
      index,
      link_text,
      insurance: normalizeString(mapInsuranceName(insurance)) ?? undefined,
    },
  });
};
